import type { ComponentType } from 'react'
import { DashboardGrid } from './DashboardGrid'
import { Widget, type WidgetSpan } from './Widget'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type WidgetComponent = ComponentType<any>

const registry = new Map<string, WidgetComponent>()

/** Every role dashboard (FR-ORG-04) composes from this same registry, by name. */
export function registerWidget(name: string, component: WidgetComponent) {
  registry.set(name, component)
}

export function getWidget(name: string): WidgetComponent | undefined {
  return registry.get(name)
}

export interface DashboardWidgetConfig {
  widget: string
  span?: WidgetSpan
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props?: Record<string, any>
}

function UnknownWidget({ name, span = 6 }: { name: string; span?: WidgetSpan }) {
  return (
    <Widget title={name} span={span}>
      <div className="text-[12.5px] text-unknown">
        Widget "{name}" is not registered — not instrumented.
      </div>
    </Widget>
  )
}

/** Renders a role dashboard from a plain config — the FR-ORG-04 entitlement layer. */
export function DashboardFromConfig({ config }: { config: DashboardWidgetConfig[] }) {
  return (
    <DashboardGrid>
      {config.map((entry, i) => {
        const Component = getWidget(entry.widget)
        if (!Component) return <UnknownWidget key={`${entry.widget}-${i}`} name={entry.widget} span={entry.span} />
        return <Component key={`${entry.widget}-${i}`} span={entry.span} {...entry.props} />
      })}
    </DashboardGrid>
  )
}
